import { render } from "./TrainingSessionVideoView.vue?vue&type=template&id=4622efc5&scoped=true"
import script from "./TrainingSessionVideoView.vue?vue&type=script&lang=js"
export * from "./TrainingSessionVideoView.vue?vue&type=script&lang=js"

import "./TrainingSessionVideoView.vue?vue&type=style&index=0&id=4622efc5&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4622efc5"]])

export default __exports__